<div [class]="shape === 'pill' ? 
  (scheduleTypeName === 'Replace' ? 
    'tw-text-yellow-700 tw-bg-yellow-100 tw-pr-2 tw-py-1 tw-rounded-full tw-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-border-yellow-300 tw-max-w-40' : 
    scheduleTypeName === 'Include' ?
    'tw-text-blue-700 tw-bg-blue-100 tw-pr-2 tw-py-1 tw-rounded-full tw-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-border-blue-300 tw-max-w-40' :
    scheduleTypeName === 'None' ?
    'tw-text-gray-700 tw-bg-white tw-pr-2 tw-py-1 tw-rounded-full tw-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-border-gray-300 tw-max-w-40' :
    '') :
  (scheduleTypeName === 'Replace' ? 
    'tw-text-yellow-700 tw-bg-yellow-100 tw-pr-2 tw-py-1 tw-rounded-md tw-flex tw-items-center tw-gap-2 tw-max-w-40' : 
    scheduleTypeName === 'Include' ?
    'tw-text-blue-700 tw-bg-blue-100 tw-pr-2 tw-py-1 tw-rounded-md tw-flex tw-items-center tw-gap-2 tw-max-w-40' :
    scheduleTypeName === 'None' ?
    'tw-text-gray-700 tw-bg-white tw-pr-2 tw-py-1 tw-rounded-md tw-flex tw-items-center tw-gap-2 tw-max-w-40' :
    '')">
  @if (scheduleTypeName === 'Replace') {
    <mat-icon svgIcon="switch" class="small tw-text-yellow-700 tw-ml-3 !tw-mr-1" />
  }
  @if (scheduleTypeName === 'Include') {
    <mat-icon svgIcon="square-check" class="small tw-text-blue-700 tw-ml-3 !tw-mr-1" />
  }
  {{ scheduleTypeName }}
</div> 